import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { SlideIn } from '.././utils/ExampleUsage'
import CustomLink from '../utils/CustomLink'

export default function AboutMe({mode}) {
    return (
        <Box 
            sx={{
                minHeight: '100%', 
                padding: '5px',
                textWrap: 'wrap'
            }}
        >
            <SlideIn direction='right'>
                <Stack 
                    direction={'column'} 
                    spacing={2}
                >
                    <Typography 
                        variant='h6' 
                        sx={{
                            fontWeight: 700, 
                            textTransform: 'uppercase', 
                            color: mode === 'dark' ? '#fff' : '#000',
                            display: {lg: 'none', xs: 'block'},
                            paddingBottom: 6
                        }}
                    >
                        About
                    </Typography>
                        <Typography 
                            variant='about' 
                            sx={{
                                color:  mode === 'dark' ? '#94A3B8' : '#727783', 
                                fontWeight: 500,
                            }}
                        >
                            My journey in technology and research began when I pursued a master's degree in Industrial Informatics at {"  "} <CustomLink 
                                href='https://www.hs-emden-leer.de/studierende/fachbereiche/technik/studiengaenge/industrial-informatics-master' 
                                linkColor = {mode === 'dark' ? '#fff' : '#000'}
                                hoverColor={mode === 'dark' ? '#5EEAD4' : '#ff5733'}
                                variant='about'
                            >Hochschule Emden/Leer</CustomLink> in Germany in 2017. During my studies, I gained practical experience as a student assistant at{" "}<CustomLink 
                                href='https://azl-aachen-gmbh.de/en/home/'
                                linkColor = {mode === 'dark' ? '#fff' : '#000'}
                                hoverColor={mode === 'dark' ? '#5EEAD4' : '#ff5733'}
                                variant='about'
                            >AZL Aachen GmbH</CustomLink> and completed my master's thesis at{"  "}<CustomLink href='https://www.ipt.fraunhofer.de/' 
                            linkColor = {mode === 'dark' ? '#fff' : '#000'}
                            hoverColor={mode === 'dark' ? '#5EEAD4' : '#ff5733'}
                            variant='about'
                            >Fraunhofer IPT</CustomLink>, setting the foundation for my career in both industry and research.
                        </Typography>
                        <Typography 
                            variant='about' 
                            sx={{
                                color:  mode === 'dark' ? '#94A3B8' : '#727783', 
                                fontWeight: 500
                            }}
                        >
                            Following graduation, I transitioned into the industry where I served as Project Engineer and Product Owner at{"  "}<CustomLink
                                href='https://www.conbility.de/en/' 
                                linkColor = {mode === 'dark' ? '#fff' : '#000'}
                                hoverColor={mode === 'dark' ? '#5EEAD4' : '#ff5733'}
                                variant='about'
                            > Conbility GmbH 
                            </CustomLink>{"  "}from 2020 to 2021. This experience strengthened my expertise in project management and product development while providing valuable insights into commercial software solutions and stakeholder management.
                        </Typography>
                    <Typography 
                        variant='about' 
                        sx={{
                            color: mode === 'dark' ? '#94A3B8' : '#727783', 
                            fontWeight: 500,
                        }}
                        >
                        In 2022, I returned to academia to pursue advanced research, joining {"  "}<CustomLink
                            href='https://www.fit.fraunhofer.de/' 
                            linkColor = {mode === 'dark' ? '#fff' : '#000'}
                            hoverColor={mode === 'dark' ? '#5EEAD4' : '#ff5733'}
                            variant='about'
                            > Fraunhofer FIT </CustomLink>{"  "}as a researcher while beginning my PhD in Computer Science at 
                             {"  "}<CustomLink 
                                href='https://www.rwth-aachen.de/go/id/a/?lidx=1' 
                                linkColor = {mode === 'dark' ? '#fff' : '#000'}
                                hoverColor={mode === 'dark' ? '#5EEAD4' : '#ff5733'}
                                variant='about'
                                > RWTH Aachen University </CustomLink>. Over the past three years, I have specialized in digital health research, developing deep expertise in eHealth solutions, healthcare interoperability standards, and clinical data management systems.
                    </Typography>
                    <Typography variant='about' sx={{color:  mode === 'dark' ? '#94A3B8' : '#727783', fontWeight: 500,}}> 
                        My work spans the development of secure, interoperable web applications with a focus on healthcare technology. I specialize in creating user-centric interfaces that prioritize accessibility and responsiveness while ensuring compliance with healthcare standards like HL7 FHIR. This unique combination of industry experience and academic research allows me to deliver practical solutions that address real-world healthcare challenges.
                    </Typography>
                    <Typography variant='about' sx={{color:  mode === 'dark' ? '#94A3B8' : '#727783', fontWeight: 500,}}>
                        Today, I leverage my diverse background spanning both commercial software development and cutting-edge research to contribute meaningfully to the digital transformation of healthcare. My passion lies in bridging the gap between innovative technology and practical healthcare applications, ensuring that digital solutions truly serve the needs of healthcare professionals and patients alike.
                    </Typography>
                </Stack>
            </SlideIn>
        </Box>
    )
}